import { render, staticRenderFns } from "./assistantlist.vue?vue&type=template&id=da55ab32&scoped=true"
import script from "./assistantlist.vue?vue&type=script&lang=js"
export * from "./assistantlist.vue?vue&type=script&lang=js"
import style0 from "./assistantlist.vue?vue&type=style&index=0&id=da55ab32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da55ab32",
  null
  
)

export default component.exports